<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="vstupenky"
        @close="dialog=false"
        @process="processForm"
        max-width="800px"
    >
        <v-text-field
            v-model="form.code"
            type="text"
            label="Kód"
            :rules="formRules.code"
        />

        <v-row>
            <v-col class="pt-0 pb-0">
                <v-text-field
                    :value="detail.price?.ticketset?.name"
                    label="Sada vstupenek"
                    disabled
                    hide-details
                ></v-text-field>
            </v-col>
            <v-col class="pt-0 pb-0">
                <v-text-field
                    :value="detail?.price?.name"
                    label="Cenová hladina"
                    disabled
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-checkbox dense hide-details
                            v-model="form.used"
                            label="Vstupenka ověřena"
                            style="position: relative; top: 10px"
                />
            </v-col>
            <v-col>
                <v-select
                        :items="devices"
                        item-text="name"
                        item-value="id"
                        v-model="form.usedById"
                        label="Ověřeno zařízením"
                        hide-details
                ></v-select>
            </v-col>
            <v-col>
                <v-text-field
                    v-model="form.usedAt"
                    type="text"
                    label="Datum ověření"
                    hide-details
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.ticketNumber"
                        type="text"
                        label="Číslo vstupenky"
                        :rules="formRules.ticketNumber"
                />
            </v-col>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.boughtAt"
                        type="text"
                        label="Zakoupeno"
                        :rules="formRules.boughtAt"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.firstName"
                        type="text"
                        label="Jméno"
                        :rules="formRules.firstName"
                />
            </v-col>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.lastName"
                        type="text"
                        label="Příjmení"
                        :rules="formRules.lastName"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.phone"
                        type="text"
                        label="Telefon"
                        :rules="formRules.phone"
                />
            </v-col>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.email"
                        type="text"
                        label="E-mail"
                        :rules="formRules.email"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pt-0 pb-0">
                <v-text-field
                        v-model="form.validUntil"
                        type="text"
                        label="Platnost do"
                        :rules="formRules.validUntil"
                />
            </v-col>
            <v-col class="pt-0 pb-0">
<!--                <v-text-field-->
<!--                        v-model="form.email"-->
<!--                        type="text"-->
<!--                        label="E-mail"-->
<!--                        :rules="formRules.email"-->
<!--                />-->
            </v-col>
        </v-row>
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                code: '',
                used: '',
                usedAt: '',
                usedById: null,
                ticketNumber: '',
                boughtAt: '',
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                validUntil: '',
            },
            formRules: {
                code: [v => v !== '' || 'Vyplňte hodnotu'],
            }
        }),

        mounted () {
            this.$store.dispatch('device/list')
        },

        computed: {
            ticketsets () {
                return this.$store.state.ticketset.list
            },
            devices () {
                return this.$store.state.device.list
            }
        },

        methods: {
            show() {
                BaseDialogMixin.methods.show.bind(this)()

                if (this.type === 'edit') {
                    this.form.usedById = this.detail.usedBy ? this.detail.usedBy.id : null
                    this.form.id = parseInt(atob(this.detail.id).split(':')[1])
                }
            }
        }
    }
</script>
